import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, PaginatedList, UtilsService } from '../../../xform-compat';
import { Observable } from 'rxjs/internal/Observable';
import { CompanyMember } from '../../../shared/models/company/company-member.model';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompanyMemberService {

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private exceptionService: ExceptionService
  ) {
  }

  /**
   * Gets company member data by company Id
   * @param {number} companyId
   * @param params
   * @returns {Observable<CompanyMember>}
   */
  public getCompanyMemberData (companyId: number, params?: any): Observable<CompanyMember> {
    return this.http.get(`/api/rms/companies/member/${companyId}`, {params: params}).pipe(
        catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Gets company members
   * @param params
   * @returns {Observable<CompanyMember>}
   */
  public getCompanyMembers(params?: any): Observable<PaginatedList<CompanyMember>> {
    return this.http.get(`/api/rms/companies/member/all`, {params: params}).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Updates the current company member
   * @param body
   * @returns {Observable<null>}
   */
  public updateCompanyMember (body: CompanyMember): Observable<null> {
    return this.http.put(`/api/rms/companies/member/update`, body)
      .pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }
}
